import * as React from 'react'

const TemplatePlaceholder = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={80} height={80} {...props}>
    <g data-name="Group 1748" transform="translate(-815.742 -256.742)">
      <rect
        data-name="Rectangle 1063"
        width={80}
        height={12}
        rx={2}
        transform="translate(815.742 256.742)"
        style={{
          fill: '#e2e2e2'
        }}
      />
      <rect
        data-name="Rectangle 1065"
        width={45}
        height={12}
        rx={2}
        transform="translate(850.742 271.742)"
        style={{
          fill: '#e2e2e2'
        }}
      />
      <rect
        data-name="Rectangle 1066"
        width={45}
        height={12}
        rx={2}
        transform="translate(850.742 286.742)"
        style={{
          fill: '#e2e2e2'
        }}
      />
      <rect
        data-name="Rectangle 1067"
        width={45}
        height={12}
        rx={2}
        transform="translate(850.742 301.742)"
        style={{
          fill: '#e2e2e2'
        }}
      />
      <rect
        data-name="Rectangle 1064"
        width={33}
        height={42}
        rx={2}
        transform="translate(815.742 271.742)"
        style={{
          fill: '#e2e2e2'
        }}
      />
      <rect
        data-name="Rectangle 1068"
        width={80}
        height={20}
        rx={2}
        transform="translate(815.742 316.742)"
        style={{
          fill: '#e2e2e2'
        }}
      />
    </g>
  </svg>
)

export default TemplatePlaceholder
